import { render, staticRenderFns } from "./ConfigurationEditor.vue?vue&type=template&id=df0c5216&scoped=true"
import script from "./ConfigurationEditor.vue?vue&type=script&lang=js"
export * from "./ConfigurationEditor.vue?vue&type=script&lang=js"
import style0 from "./ConfigurationEditor.vue?vue&type=style&index=0&id=df0c5216&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df0c5216",
  null
  
)

export default component.exports